import i18next from 'i18next';
import React from 'react';
import { bool, string } from 'prop-types';
import { useSelector } from 'react-redux/';
import cn from 'classnames';

import SectionTitle from '~screens/Commerce/screens/Checkout/components/SectionTitle';

import OrderDetailsItem from './components/OrderDetailsItem';
import styles from './styles.module.scss';

function OrderDetails({ edition, hasTitle, closeProductModalUrl, isHome }) {
  const { cart } = useSelector((state) => state.cart);
  const confirmationOrderModalIsOpen = useSelector((state) => state.modal.confirmationOrderModalIsOpen);
  return (
    <div className="column space-around full-width">
      {hasTitle && <SectionTitle>{i18next.t('OrderDetails:details')}</SectionTitle>}
      <div
        className={cn(styles.container, isHome ? styles.home : styles.checkout, {
          [styles.cartItemsInModal]: confirmationOrderModalIsOpen
        })}>
        {cart.map((item) => (
          <OrderDetailsItem
            edition={edition}
            closeProductModalUrl={closeProductModalUrl}
            key={item.id}
            item={item}
          />
        ))}
      </div>
    </div>
  );
}

OrderDetails.defaultProps = {
  edition: true,
  hasTitle: true,
  isHome: false
};

OrderDetails.propTypes = {
  closeProductModalUrl: string,
  edition: bool,
  hasTitle: bool,
  isHome: bool
};

export default OrderDetails;
